// @ts-nocheck
import React from "react";
import styled from "styled-components";

import GetAppIcon from "@material-ui/icons/GetApp";

import { formatarData } from "../ExigenciaLinhaTempo";
import { Corpo, Selo, Titulo, Aviso, Blocos, Bloco, BotaoLink, Secao, Ajuda, Etiqueta } from "./ui";

// Guia do cartão de cidadão e do passaporte (mesmo PDF anexado no e-mail de conclusão).
const LINK_GUIA = "https://drive.google.com/file/d/1VOKdpuLTvtYI_zZyfBqOjq7DoTf1gYu5/view?usp=sharing";

const cartao = [
  <>
    Agende em <b>agendamentos.mne.gov.pt</b> → Posto Consular → seu consulado → “Documento de identificação civil”
  </>,
  "Leve documento original com foto, o assento impresso em A4 e o requerimento do consulado",
  "Pague no local com cartão de débito e avise que também quer o passaporte",
];

const passaporte = [
  "Espere o consulado avisar que o cartão está pronto",
  "Agende de novo: “Documentos de viagem” → “Passaporte”",
  "Leve o cartão de cidadão, documento com foto e o requerimento",
];

const Passos = styled.div`
  border: 1px solid var(--cinza-30);
  border-radius: 12px;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  .topo {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
  }

  .topo strong {
    font-size: 15px;
    color: var(--cinza-100);
  }

  ol {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  li {
    display: flex;
    gap: 10px;
    font-size: 14px;
    line-height: 20px;
    color: var(--cinza-80);
  }

  li b {
    color: var(--cinza-100);
  }

  .num {
    width: 22px;
    height: 22px;
    border-radius: 6px;
    background: var(--cinza-30);
    color: var(--cinza-90);
    font-size: 12px;
    font-weight: 900;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
`;

const Rodape = styled.p`
  margin: 0;
  font-size: 13px;
  line-height: 19px;
  color: var(--cinza-70);
  text-align: center;
`;

function ListaPassos({ titulo, etiqueta, itens }) {
  return (
    <Passos>
      <div className="topo">
        <strong>{titulo}</strong>
        {etiqueta}
      </div>
      <ol>
        {itens.map((item, i) => (
          <li key={i}>
            <span className="num">{i + 1}</span>
            <span>{item}</span>
          </li>
        ))}
      </ol>
    </Passos>
  );
}

// Processo concluído: assento, PDF e próximos passos (cartão e passaporte).
export default function Conclusao({ process }) {
  const nome = process?.applicant?.name;
  const concluidoEm = formatarData(process?.completion_date);
  const transcricao = process?.type === "Transcrição de Casamento";

  return (
    <Corpo>
      <Selo tipo="concluido" />
      <Titulo>{transcricao ? "Casamento transcrito em Portugal" : "Parabéns pela cidadania portuguesa!"}</Titulo>
      <p className="desc">
        {transcricao ? "A transcrição do casamento de" : "O registro de"} {nome} em Portugal foi concluído{concluidoEm ? ` em ${concluidoEm}` : ""}.
      </p>

      {(process?.assento || concluidoEm) && (
        <Blocos>
          <Bloco rotulo="Assento">{process?.assento || "—"}</Bloco>
          <Bloco rotulo="Concluído em">{concluidoEm || "—"}</Bloco>
        </Blocos>
      )}

      {process?.assento_pdf && (
        <BotaoLink href={process.assento_pdf} target="_blank" rel="noopener noreferrer">
          <GetAppIcon />
          Baixar certidão do assento (PDF)
        </BotaoLink>
      )}

      {!transcricao && (
        <>
          <Aviso tipo="cliente">
            <b>Antes: atualize o estado civil (caso seja casado)</b>
            <p>Para o cartão de cidadão e o passaporte saírem corretos, o casamento precisa estar transcrito em Portugal.</p>
          </Aviso>

          <Secao>Próximos passos</Secao>
          <ListaPassos titulo="1 · Cartão de cidadão" etiqueta={<Etiqueta tipo="equipe">Primeiro</Etiqueta>} itens={cartao} />
          <ListaPassos titulo="2 · Passaporte" etiqueta={<Etiqueta>Depois do cartão</Etiqueta>} itens={passaporte} />

          <Ajuda titulo="Consulados no Brasil">
            <p>São Paulo · Rio de Janeiro · Belo Horizonte · Porto Alegre. Outras cidades: contatos no Portal das Comunidades.</p>
          </Ajuda>

          <BotaoLink secundario href={LINK_GUIA} target="_blank" rel="noopener noreferrer">
            Baixar o guia completo (PDF)
          </BotaoLink>
          <Rodape>Sem despachante: o consulado pede que cada cidadão faça o próprio agendamento.</Rodape>
        </>
      )}
    </Corpo>
  );
}
